import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import classNames from 'classnames';
import useSidebarContext from '@/hooks/useSidebarContext';
import Footer from './Footer/Footer';
import Header from './Header/Header';
import MobileHeader from './MobileHeader/MobileHeader';
import Sidebar from './Sidebar/Sidebar';
import styles from './Layout.module.scss';

type LayoutProps = {
  isPrivate?: boolean;
  flexStart?: boolean;
};

const Layout: FC<LayoutProps> = ({ isPrivate, flexStart }) => {
  const { isSidebarAnchored } = useSidebarContext();

  const getMarginClassname = () => {
    if (isPrivate && isSidebarAnchored) {
      return styles.openSidebarMargin;
    }
    if (isPrivate && !isSidebarAnchored) {
      return styles.collapsedSidebarMargin;
    }
    return null;
  };

  return (
    <div className={styles.layout}>
      {isPrivate && <Sidebar />}
      <div
        className={classNames(
          styles.layoutContent,
          !isPrivate && styles.publicBackground,
          !isPrivate && 'publicBackground',
          getMarginClassname()
        )}
      >
        <Header isPrivate={isPrivate} />
        <MobileHeader />
        <main
          className={classNames(
            flexStart && isPrivate ? styles.layoutContentMain : undefined,
            flexStart && !isPrivate ? styles.layoutContentMainPublic : undefined
          )}
        >
          <Outlet />
        </main>
        <Footer isPrivate={isPrivate} />
      </div>
    </div>
  );
};

export default Layout;
